import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { SingleStreakStar } from "./SingleStreakStar";
import { useEffect, useState, useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import { UserCtx } from "../../../interfaces";
import { getNumericDayFromDate } from "../../../Helpers";

const useStyle = makeStyles((theme) => ({
  overviewCard: {
    display: "flex",
    color: "#FFFFFF",
    backgroundImage: "linear-gradient(to right, #8C1D40, #802642)",
    borderRadius: "0.625rem",
    boxShadow: "0px 0.2rem 1.25rem #00000015",
  },
  pinkText: {
    color: theme.palette.secondary.main,
  },
}));

const days = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const reverse = (dayIndex: number) => {
  let split = (3 - dayIndex) * -1;
  let firstHalf = days.slice(0, split).reverse();
  let secondHalf = days.slice(split, days.length).reverse();
  let arr = firstHalf.concat(secondHalf).reverse();
  return arr;
};

export const StreakCard = () => {
  const [rotatedArr, setRotatedArr] = useState<string[]>([]);
  const [filledStar, setFilledStar] = useState<string[]>([]);
  const classes = useStyle();
  const userCtx = useContext(UserContext) as UserCtx;
  const filledIndex = userCtx.userStreak;
  let todaysDay = new Date().getDay();

  useEffect(() => {
    if (filledIndex.length === 0) {
      return;
    }
    if (filledIndex.length >= 7) {
      setFilledStar(days);
      return;
    }
    for (var i = 0; i < filledIndex.length; i++) {
      let day = days[getNumericDayFromDate(new Date(filledIndex[i]))];
      setFilledStar((prev) => {
        return [...prev, day];
      });
    }
  }, [filledIndex]);
  useEffect(() => {
    setRotatedArr(reverse(todaysDay));
  }, [todaysDay]);
  return (
    <Card
      sx={{
        padding: "2rem",
        marginBottom: "24px",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
        }}>
        <Typography
          sx={{
            mb: 1.5,
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "0.75rem",
          }}
          variant="h4"
          component="div">
          {filledIndex.length ? (
            <div>
              <span className={classes.pinkText}>{filledIndex.length} Day </span>
              streak!
            </div>
          ) : (
            <div>Start your streak!</div>
          )}
        </Typography>
        <Typography
          sx={{
            marginBottom: "0.75rem",
          }}
          variant="body2"
          component="div">
          {filledIndex.length ? (
            <div>
              {filledIndex.includes(new Date().toISOString().split("T")[0]) ? (
                <span>Come back tomorrow so it doesn't reset.</span>
              ) : (
                <span>Keep it up, you're amazing at this.</span>
              )}
            </div>
          ) : (
            <div>
              <span>Complete a problem to start your streak.</span>
            </div>
          )}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: { xs: "1px", sm: "2px", md: "4px", lg: "12px" },
            alignItems: "center",
            justifyContent: "center",
          }}>
          {rotatedArr.map((day, index) => (
            <SingleStreakStar
              key={index}
              day={day}
              isFilled={filledStar.includes(day)}
              isCenter={index === (rotatedArr.length - 1) / 2}
            />
          ))}
        </Box>
      </Box>
    </Card>
  );
};
